/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */

var cleanUpResponse = require('common/util/cleanUpResponse');

module.exports = function() {
  var deferred = $.Deferred();

  $.soap({
    body: {
      GetAllBankSubsidiaryLookups: {
        $xmlns: 'http://dobs.pa.gov/dp/lookup/bpm/1.0'
      }
    },
    blueprintArrays: [
      'GetAllSubsidiaryLookupsResponse.BankTypes.DP_LU_BankSubsidiaryBankType',
      'GetAllSubsidiaryLookupsResponse.BankingCodes.DP_LU_BankSubsidiaryBankingCode',
      'GetAllSubsidiaryLookupsResponse.Authorities.DP_LU_BankSubsidiaryAuthority',
      'GetAllSubsidiaryLookupsResponse.ActivityTypes.DP_LU_BankParitySubsidiaryActivityType',
      'GetAllSubsidiaryLookupsResponse.OwnershipStructures.DP_LU_EntityOwnershipStructure',
      'GetAllSubsidiaryLookupsResponse.FedRegulators.DP_LU_BankSubsidiaryFedRegulator'
    ],
    blueprint: {
      bankTypes: [
        '$..DP_LU_BankSubsidiaryBankType',
        {
          id: '$..ID',
          type: '$..Type'
        }
      ],
      bankingCodes: [
        '$..DP_LU_BankSubsidiaryBankingCode',
        {
          id: '$..ID',
          code: '$..BankingCode'
        }
      ],
      authorities: [
        '$..DP_LU_BankSubsidiaryAuthority',
        {
          id: '$..ID',
          authority: '$..Authority'
        }
      ],
      activityTypes: [
        '$..DP_LU_BankParitySubsidiaryActivityType',
        {
          id: '$..ID',
          type: '$..ActivityType'
        }
      ],
      ownershipStructures: [
        '$..DP_LU_EntityOwnershipStructure',
        {
          id: '$..ID',
          structure: '$..Structure'
        }
      ],
      fedRegulators: [
        '$..DP_LU_BankSubsidiaryFedRegulator',
        {
          id: '$..ID',
          regulator: '$..Regulator'
        }
      ]
    }
  })
    .done(function(response) {
      cleanUpResponse(response);
      deferred.resolve(response);
    })
    .fail(function(err) {
      deferred.reject();
    });

  return deferred.promise();
};
